<template>
    <div class="body-time-single">
        <div class="border-time-single">
            <div class="type-items">
                <div class="item-type my-cursor" @click.stop="setTimeType('point')">
                    时间点
                    <div class="img-time-line" :style="{visibility: timeType === 'point'? 'visible': 'hidden'}"></div>
                </div>
                <div class="item-type my-cursor" @click.stop="setTimeType('slot')">
                    时间段
                    <div class="img-time-line" :style="{visibility: timeType === 'slot'? 'visible': 'hidden'}"></div>
                </div>
            </div>

            <div class="scroll-box" v-show="timeType === 'point'">
                <div class="scroll-hour">
                    <ScrollModule :items="hours" :selected="point.hour" @submitEvent="setSelect($event, 'point', 'hour')"/>
                </div>
                <div class="text-center">:</div>
                <div class="scroll-minute">
                    <ScrollModule :items="minutes" :selected="point.minute" @submitEvent="setSelect($event, 'point', 'minute')"/>
                </div>
            </div>

            <div class="scroll-box" v-show="timeType === 'slot'">
                <div class="scroll-start">
                    <div class="start-hour">
                        <ScrollModule :items="hours" :selected="slot.start.hour" @submitEvent="setSelect($event,'slotStart','hour')"/>
                    </div>
                    <div class="text-center">:</div>
                    <div class="start-minute">
                        <ScrollModule :items="minutes" :selected="slot.start.minute" @submitEvent="setSelect($event,'slotStart','minute')"/>
                    </div>
                </div>
                <div class="coupling">-</div>
                <div class="scroll-end">
                    <div class="end-hour">
                        <ScrollModule :items="hours" :selected="slot.end.hour" @submitEvent="setSelect($event,'slotEnd','hour')"/>
                    </div>
                    <div class="text-center">:</div>
                    <div class="end-minute">
                        <ScrollModule :items="minutes" :selected="slot.end.minute" @submitEvent="setSelect($event,'slotEnd','minute')"/>
                    </div>
                </div>
            </div>

            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "./ScrollModule";
import initData from "@/utils/initData";
export default {
    name: "TimeSingle",
    components: {
        ScrollModule
    },
    data(){
        return {
            timeType: "point",
            point: {
                hour: "00",
                minute: "00"
            },
            slot: {
                start: {
                    hour: "00",
                    minute: "00"
                },
                end: {
                    hour: "00",
                    minute: "00"
                }
            },
            hours: initData.hours,
            minutes: initData.minutes,
        }
    },
    props: {
        startTime: {
            type: Number,
            default: -1,
        },
        endTime: {
            type: Number,
            default: -1,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", {timeType: this.timeType, point: this.point, slot: this.slot});
            this.close();
        },
        setTimeType: function(timeType){
            if(this.timeType === timeType){
                return
            }
            this.timeType = timeType;
            if(timeType === "point"){
                this.point.hour = this.slot.start.hour;
                this.point.minute = this.slot.start.minute;
            }else{
                this.slot.start = {
                    hour: this.point.hour,
                    minute: this.point.minute
                };
                this.slot.end = {
                    hour: this.point.hour,
                    minute: this.point.minute
                }
            }
        },
        setSelect: function(value, timeType, valueType) {
            if("point" === timeType){
                // 时间点
                if("hour" === valueType){
                    // 小时
                    this.point.hour = value
                }else{
                    // 分钟
                    this.point.minute = value
                }
            }else if("slotStart" === timeType){
                // 时间段 开始
                if("hour" === valueType){
                    // 小时
                    this.slot.start.hour = value;
                    if(this.slot.end.hour < value){
                        // 开始小时 > 结束小时 重置结束
                        this.slot.end.hour = value;
                        this.slot.end.minute = this.slot.start.minute;
                    }else if(this.slot.end.hour === value && this.slot.end.minute < this.slot.start.minute){
                        // 开始小时 = 结束小时， 开始分钟 > 结束分钟 重置结束
                        this.slot.end.minute = this.slot.start.minute;
                    }
                }else{
                    // 分钟
                    this.slot.start.minute = value;
                    if(this.slot.start.hour === this.slot.end.hour && value > this.slot.end.minute){
                        // 开始小时 = 结束小时 开始分钟 > 结束分钟 重置结束
                        this.slot.end.minute = value;
                    }
                }
            }else{
                // slotEnd 时间段结束
                if("hour" === valueType){
                    // 小时
                    this.slot.end.hour = value;
                    if(this.slot.start.hour > value){
                        // 开始小时 > 结束小时 重置开始
                        this.slot.start.hour = value;
                        this.slot.start.minute = this.slot.end.minute;
                    }else if(this.slot.start.hour === value && this.slot.start.minute > this.slot.end.minute){
                        // 开始小时 = 结束小时 开始分钟 > 结束分钟 重置开始
                        this.slot.start.minute = this.slot.end.minute;
                    }
                }else{
                    // 分钟
                    this.slot.end.minute = value;
                    if(this.slot.start.hour === this.slot.end.hour && this.slot.start.minute > value){
                        // 开始小时 = 结束小时 开始分钟 > 结束分钟 重置开始
                        this.slot.start.minute = value;
                    }
                }
            }
        },
    },
    mounted(){

        if(this.endTime === -1){
            // 时间点
            this.timeType = "point";

            if(this.startTime === -1){
                // 当前时间
                const currentTime = new Date();
                this.point = {
                    hour: this.$Utils.addZero(currentTime.getHours()),
                    minute: this.$Utils.addZero(currentTime.getMinutes()),
                }
            }else{
                // 目标时间
                this.point = this.$Utils.minuteToTime(this.startTime);
            }
        }else{
            this.timeType = "slot";
            this.slot.start = this.$Utils.minuteToTime(this.startTime);
            this.slot.end = this.$Utils.minuteToTime(this.endTime);
        }
    }
}
</script>

<style scoped>

div.body-time-single{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-time-single{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}

div.type-items{
    width: 100%;
    display: flex;
    gap: 0.7rem;
    justify-content: center;
    box-sizing: border-box;
}

div.item-type{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.img-time-line{
    width: 0.64rem;
    height: 0.07rem;
    background: url("../../../assets/images/List/img-time-line.png");
    background-size: cover;
    margin: -0.04rem auto auto;
}
div.scroll-box{
    width: 100%;
    height: 1.7rem;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    margin-top: 0.2rem;

    box-sizing: border-box;
    padding: 0.23rem 0.3rem;

    display: flex;
    align-items: center;
}
div.scroll-hour, div.scroll-minute{
    flex: 1;
    height: 100%;
    text-align: center;
}
div.scroll-hour{
    text-align: right;
}
div.scroll-minute{
    text-align: left;
}

div.text-center{
    width: 1rem;
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    text-align: center;
    font-style: normal;
}
div.scroll-start, div.scroll-end{
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
div.coupling{
    width: 0.7rem;
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    text-align: center;
    font-style: normal;
}
div.scroll-start div.text-center, div.scroll-end div.text-center{
    width: 0.5rem;
}

div.start-hour, div.start-minute, div.end-hour, div.end-minute{
    flex: 1;
    height: 100%;
    text-align: center;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>